import { render, staticRenderFns } from "./tuanOptimization.vue?vue&type=template&id=61a33478&scoped=true&"
import script from "./tuanOptimization.vue?vue&type=script&lang=js&"
export * from "./tuanOptimization.vue?vue&type=script&lang=js&"
import style0 from "./tuanOptimization.vue?vue&type=style&index=0&id=61a33478&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a33478",
  null
  
)

export default component.exports